export default __webpack_public_path__ + "static/media/Mercenary's Helm of Grinning Skulls.f434cf85.jpg";